import { render, staticRenderFns } from "./BeatLoaderComponent.vue?vue&type=template&id=77b8ce18"
import script from "./BeatLoaderComponent.vue?vue&type=script&lang=js"
export * from "./BeatLoaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports